/**
 * Enable interactive to-do list checkboxes
 * This script removes the disabled attribute from CKEditor to-do list checkboxes
 * and makes them interactive for users
 */
document.addEventListener('DOMContentLoaded', function() {
    // Find all to-do list checkboxes
    const todoCheckboxes = document.querySelectorAll('.todo-list input[type="checkbox"]');
    
    todoCheckboxes.forEach(function(checkbox) {
        // Remove the disabled attribute to make it interactive
        checkbox.removeAttribute('disabled');
        
        // Add event listener for checkbox changes
        checkbox.addEventListener('change', function() {
            // Optional: You can add additional functionality here
            // For example, saving the state to localStorage or sending to server
            console.log('Todo item toggled:', this.checked);
            
            // You could also add visual feedback or animations here
            const listItem = this.closest('li');
            if (this.checked) {
                listItem.style.opacity = '0.7';
                listItem.style.textDecoration = 'line-through';
            } else {
                listItem.style.opacity = '1';
                listItem.style.textDecoration = 'none';
            }
        });
    });
    
    console.log(`Enabled ${todoCheckboxes.length} to-do list checkboxes`);
});
